import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ModalClass } from 'src/app/models/modal-model';

@Component({
  selector: 'app-dynamic-modal',
  templateUrl: './dynamic-modal.component.html',
  styleUrls: ['./dynamic-modal.component.scss']
})
export class DynamicModalComponent  {
  @Output() StatusEmitbutton: EventEmitter<boolean>;
  @Input() Body: ModalClass;
  @Input() popupPostApproval: boolean;

  constructor() {
    this.StatusEmitbutton = new EventEmitter(null);
  }
 
  buttonreturn(boolean: boolean) {
    this.StatusEmitbutton.emit(boolean)
  }

}
